import { useState, useCallback } from 'react';
import ReactMapGL, {
  NavigationControl,
  Source,
  Layer,
  LinearInterpolator,
  WebMercatorViewport
} from 'react-map-gl';
import { data } from 'data/us-states';
import {
  MAPBOX_TOKEN,
  LATITUDE,
  LONGITUDE,
  navControlStyle,
  MAPBOX_STYLE_DARK,
  MAPBOX_STYLE_LIGHT
} from 'utils/map';
import { useTheme } from 'contexts/theme';
import { dataLayer } from './layers/states';
import { heatmapLayer } from './layers/heatmap';
import ControlPanel from './controlPanel';

import 'mapbox-gl/dist/mapbox-gl.css';

import styles from './map.module.sass';

const Map = ({
  width = 'calc(100vw - 20px)',
  height = 'calc(100vh - 72px)'
}: {
  width?: string;
  height?: string;
}) => {
  const { dark } = useTheme();
  const [hoverInfo, setHoverInfo] = useState<any>(null);
  const [statesLayer, setStatesLayer] = useState(true);
  const [heatLayer, setHeatLayer] = useState(false);
  const [viewport, setViewport] = useState({
    latitude: LATITUDE,
    longitude: LONGITUDE,
    zoom: 2
  });

  const onHover = useCallback((event) => {
    const {
      features,
      srcEvent: { offsetX, offsetY }
    } = event;
    const hoveredFeature = features && features[0];

    setHoverInfo(
      hoveredFeature
        ? {
            feature: hoveredFeature,
            x: offsetX,
            y: offsetY
          }
        : null
    );
  }, []);

  const onClick = (event: any) => {
    const feature = event.features[0];
    const { lngLat } = event;
    if (feature) {
      setViewport({
        ...viewport,
        longitude: lngLat[0],
        latitude: lngLat[1],
        zoom: 5
      });
    }
  };

  return (
    <ReactMapGL
      {...viewport}
      width={width}
      height={height}
      onViewportChange={(nextViewport: any) => setViewport(nextViewport)}
      mapboxApiAccessToken={MAPBOX_TOKEN}
      interactiveLayerIds={['states']}
      onHover={onHover}
      onClick={onClick}
      mapStyle={dark ? MAPBOX_STYLE_DARK : MAPBOX_STYLE_LIGHT}
      minZoom={2}
    >
      <NavigationControl style={navControlStyle} showCompass={false} />
      <ControlPanel
        setStatesLayer={setStatesLayer}
        setHeatLayer={setHeatLayer}
      />
      <Source type="geojson" data={data}>
        {statesLayer && <Layer {...dataLayer} />}
        {heatLayer && <Layer {...heatmapLayer} />}
      </Source>
      {hoverInfo && (
        <div
          className={styles.hover}
          style={{ left: hoverInfo.x, top: hoverInfo.y }}
        >
          <div>State: {hoverInfo.feature.properties.name}</div>
          <div>Density: {hoverInfo.feature.properties.density}</div>
        </div>
      )}
    </ReactMapGL>
  );
};

export default Map;
